const API_URL = "http://localhost:5000/books"; // placeholder

export const getBooks = async () => {
  const response = await fetch(API_URL);
  return response.json();
};

export const addBook = async (book) => {
  const response = await fetch("http://localhost:5000/books", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(book),
  });
  return response.json();
};

export const getBookById = async (id) => {
  const response = await fetch(`http://localhost:5000/books/${id}`);
  return response.json();
};

export const updateBook = async (id, book) => {
  const response = await fetch(`http://localhost:5000/books/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(book),
  });
  return response.json();
};

export const deleteBook = async (id) => {
  await fetch(`http://localhost:5000/books/${id}`, {
    method: "DELETE",
  });
};

